// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"cca0d169","545":"319aa1a1","598":"9c378c9d","787":"ba295ff5"}[chunkId] + ".chunk.js";
};